export enum SvcGamificationLocalStorage {
  IsGamefied = 'isGamefied',
}
